/**
 * Constants for Risk Status Threshold module
 */

// Dialog Text Constants
export const DIALOG_TEXT = {
  // Reset Dialog
  RESET_CONFIRMATION_TITLE_TEMPLATE: (commodityName: string) =>
    `Are you sure you want to reset ${commodityName} to the Default Thresholds?`,
  RESET_SUBTITLE_TEMPLATE: (commodityName: string) => commodityName,
  RESET_OVERWRITE_MSG_TEMPLATE: (commodityName: string) =>
    `This action will overwrite the current threshold values for ${commodityName} to match the default configuration.`,

  // Edit Dialog
  EDIT_TITLE_TEMPLATE: (commodityName: string) =>
    `Edit ${commodityName.toLowerCase().includes("default threshold") ? "Default" : commodityName} Thresholds`,

  // Unsaved Changes Dialog
  UNSAVED_TITLE: "Unsaved Changes",
  UNSAVED_MESSAGE:
    "You have unsaved changes. Are you sure you want to close? Your changes will be lost.",

  // Button Labels
  CANCEL_TEXT: "Cancel",
  CONFIRM_TEXT: "Confirm",
  SAVE_TEXT: "Save",
  YES_TEXT: "Yes",
  SAVING_TEXT: "Saving...",
  DISCARD_TEXT: "Discard Changes",
  KEEP_EDITING_TEXT: "Keep Editing",
} as const;

// Icon Names
export const ICONS = {
  EDIT: "edit",
  RESET: "reset",
  WARNING: "⚠️",
} as const;

// Test IDs
export const TEST_IDS = {
  EDIT_THRESHOLD: "edit-threshold-icon",
  RESET_THRESHOLD: "reset-threshold-icon",
} as const;

// Slider Constants
export const SLIDER_TEXT = {
  RISK_STATUS_THRESHOLD: "Risk Status Threshold",
  HIGH_LABEL: "High",
  MEDIUM_LABEL: "Medium",
  LOW_LABEL: "Low",
  MODIFIED_VALUES: "Modified Values",
  ORIGINAL_VALUES: "Original",
} as const;

// CSS Classes
export const CSS_CLASSES = {
  POINTER_CURSOR: "cursor-pointer",
  FLEX_CENTER: "flex items-center",
  DIALOG_HEADER: "px-8 py-6",
  DIALOG_CONTENT: "px-8 py-6",
  DIALOG_CONTENT_EDIT: "px-8 py-8 min-h-[400px] flex items-center justify-center",
  DIALOG_FOOTER: "px-8 py-5",
} as const;

// Default User Email Domain
export const DEFAULT_EMAIL_DOMAIN = "@costco.com";

// Default fallback username
export const DEFAULT_USERNAME = "admin";
